import { useState } from 'react';
import apiConfig from '../globalConfig/apiConfig';

const NEW_SITE_URL = apiConfig.internalHost;

export const useDeprecationDialog = () => {
  console.log('New site URL from config:', NEW_SITE_URL);
  const [isDialogOpen, setIsDialogOpen] = useState(true);

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  const handleGoToNewSite = () => {
    window.location.href = NEW_SITE_URL;
  };

  return {
    isDialogOpen,
    handleClose,
    handleGoToNewSite,
  };
};
